import { render, staticRenderFns } from "./AssessmentInfo.vue?vue&type=template&id=89be2d7a&scoped=true&"
import script from "./AssessmentInfo.vue?vue&type=script&lang=js&"
export * from "./AssessmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89be2d7a",
  null
  
)

export default component.exports